import { authHeader } from '../../../auth';

export default {
    name: "Effects",
    components: {
    },
    data() {
        return {
            dataList: [],
            setURL: this.$serverURL + this.$api.effect.requestURL,
            singleData: {},
            previewIcon: "",
            updateIcon: "",
            tempDataList: [],
            searchKey: ""
        }
    },
    async created() {
        document.title = "Dispo - Effects";
        await this.getData();
        var scripts = [
            "/core/assets/plugins/datatable/js/jquery.dataTables.min.js",
            "/core/assets/plugins/datatable/js/dataTables.bootstrap5.min.js",
            "/core/assets/js/table-datatable.js"
        ];
        scripts.forEach(script => {
            let tag = document.createElement("script");
            tag.setAttribute("src", script);
            document.head.appendChild(tag);
        });
        let style = document.createElement('link');
        style.type = "text/css";
        style.rel = "stylesheet";
        style.href = '/core/assets/plugins/datatable/css/dataTables.bootstrap5.min.css';
        document.head.appendChild(style);
    },
    methods: {
        async getData() {
            const response = await this.getDataList(this.setURL);
            this.dataList = response;
            this.tempDataList = response;
        },
        searchCategory() {
            let newArr = [...this.dataList];
            let searchVal = this.searchKey.toUpperCase();
            let filteredArr = [];
            newArr.forEach((el) => {
                let effects = el?.effects?.toUpperCase();
                if (effects.includes(searchVal)) {
                    filteredArr.push(el);
                }
            });
            this.tempDataList = filteredArr;
        },
        editData(data) {
            this.singleData = data;
        },
        onIconChange(event) {
            this.updateIcon = event.target.files[0];
            let input = this.$refs.icon;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader;
                reader.onload = e => {
                    this.previewIcon = e.target.result;
                }
                reader.readAsDataURL(file[0]);
            }
        },
        update: async function () {
            const formData = new FormData();
            formData.append("icon", this.updateIcon ? this.updateIcon : this.singleData.icon);
            let config = {
                method: "PATCH",
                url: this.setURL + '/' + this.singleData.id,
                data: formData,
                headers: authHeader()
            };
            this.$swal.showLoading();
            await this.$axios(config).then(async (response) => {
                this.$swal.close();
                if (response.data.statusCode == 200) {
                    this.singleData = {};
                    this.$refs.icon.value = "";
                    this.updateIcon = "";
                    this.previewIcon = "";
                    this.dataList = [];
                    this.tempDataList = [];
                    await this.getData();
                    document.getElementById("close-btn").click();
                    this.$swal.fire({
                        toast: true,
                        position: 'top-end',
                        text: response.data.message,
                        icon: "success",
                        showConfirmButton: false,
                        timer: 3000,
                        animation: false,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', this.$swal.stopTimer)
                            toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                        }
                    });
                }
            }).catch(error => {
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: error.response.data.message
                });
            });
        },
    },
    watch: {
        searchKey: function () {
            this.searchCategory();
        }
    }
}